<template lang="pug">
    transition(name="layout-slide")
        v-content(v-if="mountedComponent")
            v-container(:class="{'fluid': fluid}" grid-list-lg)
                v-layout(row wrap)
                    v-flex(xs12)
                        div.title(v-if="hasTitleSlot")

                            // Page main Title
                            slot(name="title")

                        div.contentInner

                            // Content
                            slot
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            fluid: VueTypes.bool.def(false)
        },
        data() {
            return {
                mountedComponent: false
            };
        },
        computed: {
            hasTitleSlot() {
                return !!this.$slots.title;
            }
        },
        mounted() {
            this.mountedComponent = true;
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../assets/style/_variables.styl";

    .title
        padding: 16px 0 0

    .contentInner
        background: $theme.info
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1)
        border-radius: 10px
        padding: 16px 0

    .contentTransparent .contentInner
        background-color: transparent
        box-shadow: none

    .contentWithoutBackground .contentInner
        background: none
        box-shadow: none

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .contentInner
            margin-bottom: 30px

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .title
            margin: 0 0 8px

        .contentInner
            padding: 0
            margin-bottom: 8px
</style>
